import React from 'react';
import { Dialog } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import CircledPopUpFrame from '../Core/CircledPopUpFrame';
import { ElevatedCircle } from '../Core/ElevatedCircle';
import { ReactComponent as RenewSvg } from '../../assets/renew.svg';
import NewFillButton from '../Core/NewFillButton';
import FlexView from 'react-flexview/lib';
import dayjs from 'dayjs';
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';
import { ActiveInsuranceModel } from '../../models/insurance-models/ActiveInsuranceModel';

interface AutoRenewalConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    insurance: ActiveInsuranceModel;
}

export const AutoRenewalConfirmationDialog = ({ open, onClose, onConfirm, insurance }: AutoRenewalConfirmationDialogProps) => {
    return (
        <Dialog
            BackdropProps={{style: {backgroundColor: 'white', opacity: 0.64}}}
            fullWidth
            open={open}
            onClose={onClose}
            PaperProps={{style: {backgroundColor: 'transparent', boxShadow: 'none'}}}
            maxWidth={'xs'}>
            <CircledPopUpFrame onCancel={onClose} circleHeader={<ElevatedCircle> <RenewSvg className="medium-icon blue-svg-path" /></ElevatedCircle>}>
                <div className="text-body blue bold textcenter">Are you sure you want to turn off your auto-renewal?</div>
                <br />
                <div className="text-small black textcenter margin-top-basic">You will not be covered after {dayjs(insurance.insuranceEnd).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT))}</div>
                <br />
                <FlexView column={isMobile} className="margin-top-basic space-between margin-bottom-basic">
                    {!isMobile && <NewFillButton darkblue onClick={onClose}>No</NewFillButton>}
                    <NewFillButton onClick={onConfirm}>Yes</NewFillButton>
                    {isMobile && <NewFillButton darkblue onClick={onClose}>No</NewFillButton>}
                </FlexView>
            </CircledPopUpFrame>
        </Dialog>
    );
};